module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_dutch_bucket2.eb019fa4.webp";